import { c as _c } from "react/compiler-runtime";
import SpecificTriggerRules from 'modules/automation-rules/specific-trigger-rules';
import { getDefaultTriggerValue } from 'modules/automation-rules/triggers/utils/get-default-trigger-value';
import { useStoreOptinRules } from 'modules/stores/store/content/optin/optin-rules/hooks/use-store-optin-rules';
import { useStoreOptinTriggers } from 'modules/stores/store/content/optin/optin-rules/hooks/use-store-optin-triggers';
import { useStoreRuleData } from 'modules/stores/store/content/optin/optin-rules/hooks/use-store-rule-data';
import { fillTriggerWithStoreData } from 'modules/stores/store/content/optin/optin-rules/utils/fill-trigger-with-store-data';
import { splitRelatedAndUnrelatedTriggers } from 'modules/stores/store/content/optin/optin-rules/utils/split-related-and-unrelated-triggers';
import { StoreId } from 'modules/stores/types/stores-interface';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface OptinRulesProps {
  storeId: StoreId;
  optinId: number;
}
function OptinRules(t0) {
  const $ = _c(12);
  const {
    storeId,
    optinId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const specificTriggerRulesData = useStoreOptinRules(optinId);
  const availableTriggersData = useStoreOptinTriggers(optinId);
  const {
    storeTriggerData
  } = useStoreRuleData(storeId, optinId);
  let t1;
  if ($[0] !== t) {
    t1 = id => <TransLoco t={t} components={{
      a: <LinkWithoutPrefetch href={`/automation-rules/${id}`} className="primary-link" />
    }} i18nKey="dashboard.automation_rule.trigger.has_non_related_store_optin" />;
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== storeTriggerData?.itemId) {
    t2 = triggers => splitRelatedAndUnrelatedTriggers(triggers, storeTriggerData?.itemId);
    $[2] = storeTriggerData?.itemId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== storeTriggerData) {
    t3 = storeTriggerData && ((trigger, maxTriggerId) => fillTriggerWithStoreData(getDefaultTriggerValue(trigger, maxTriggerId), storeTriggerData));
    $[4] = storeTriggerData;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== availableTriggersData || $[7] !== specificTriggerRulesData || $[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = <SpecificTriggerRules noRelatedMessage={t1} availableTriggersData={availableTriggersData} specificTriggerRulesData={specificTriggerRulesData} getRelatedAndUnrelatedTriggersData={t2} customAddTriggerHandler={t3} />;
    $[6] = availableTriggersData;
    $[7] = specificTriggerRulesData;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
export default OptinRules;